import { useEffect } from "react";
import { useState } from "react";
import { Activity, MeetupsState, MeetupsTableItemType } from "../../../types";
import { meetupsTableItems as initialMeetups } from "../../../misc/constants";
import MeetupsAdminTable from "./MeetupsAdminTable/MeetupsAdminTable";
import MeetupsAdminControl from "./MeetupsAdminControl/MeetupsAdminControl";
import MeetupsDescrCard from "./MeetupsDescrCard/MeetupsDescrCard";
import MeetupsDescrCardButton from "./MeetupsDescrCardButtons/MeetupsDescrCardButtons";
import MeetupsRejectModal from "./MeetupsRejectModal/MeetupsRejectModal";
import { useHookstate } from "@hookstate/core";
import MeetupsControl from "../MeetupsControl";
import MeetupsTable from "../MeetupsTable";
import { useGlobalMiscState } from "../../../stores/misc";
import Modal from "../../Modal/Modal";
import { updateMiscState } from "../../../misc/utils";
import { MeetupsApproveModal } from "./MeetupsApproveModal";
import MeetupsCommentModal from "../MeetupsCommentModal/MeetupsCommentModal";
type Props = {
  display: string;
};

export default function MeetupsAdmin({ display }: Props) {
  const miscState = useGlobalMiscState();
  const isDescrOpen = Boolean(miscState.get('isMeetupsAddFormOpen'))
  const isRejectModalOpen = Boolean(miscState.get('isMeetupsRejectModalOpen'))
  const isMeetupsApproveModalOpen = Boolean(miscState.get('isMeetupsApproveModalOpen'))
  const isCommentModalOpen = Boolean(miscState.get('isMeetupsCommentModalOpen'))
  const currentMeetupForComment: Activity | null = miscState.get('meetupsFormEditItem') || null;
  const localState = useHookstate<MeetupsState>({} as MeetupsState);

  useEffect(() => {
    miscState.set('meetupsFormEditItem', {})
  }, [])

  const setIsDescrOpen = (value: boolean) => {
    miscState.set('isMeetupsAddFormOpen', value)
  }

  const setIsRejectModalOpen = (value: boolean) => {
    miscState.set('isMeetupsRejectModalOpen', value)
  }

  const [focusedMeet, setFocusedMeet] = useState<MeetupsTableItemType | null>(
    null
  );
  const [currentMeet, setCurrentMeet] = useState<MeetupsTableItemType | null>(
    null
  );

  const [filteredMeetups, setFilteredMeetups] = useState(initialMeetups);

  useEffect(() => {
    currentMeet ? setIsDescrOpen(true) : setIsDescrOpen(false);
  }, [currentMeet]);

  const handleApprove = () => {
    if (currentMeet) {
      currentMeet.status = "approved";
      setFilteredMeetups((prevFilteredMeetups) =>
        prevFilteredMeetups.filter((meetup) => meetup.id !== currentMeet.id)
      );
      setIsDescrOpen(false);
    }
  };

  return (
    <div className="flex flex-col lg:flex-row gap-3 sm:gap-4 h-full overflow-hidden">
      <div
        className={`bg-white rounded-xl shadow-sm overflow-hidden flex flex-col ${isDescrOpen ? "lg:w-[40%] w-full" : "w-full"
          }`}
      >
        <div className="flex flex-col overflow-y-auto flex-1 min-h-0 w-full">
          <div className="p-3 sm:p-4 md:p-5 w-full">
            <MeetupsControl
              localState={localState}
              isAddFormOpen={isDescrOpen}
            />
          </div>
          <div className="flex-1 overflow-y-auto w-full overflow-x-scroll">
            <MeetupsTable
              display={display}
              localState={localState}
              isAddFormOpen={isDescrOpen}
            />
          </div>
        </div>
        {isRejectModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40">
            <MeetupsRejectModal
              setIsRejectModalOpen={setIsRejectModalOpen}
            />
          </div>
        )}
        <Modal
          visible={isMeetupsApproveModalOpen}
          setVisible={updateMiscState('isMeetupsApproveModalOpen')}
          additionalClassName='!w-[90%] md:!w-[32.5%] rounded-xl flex flex-col p-4 md:p-8'
        >
          <MeetupsApproveModal />
        </Modal>
        {isCommentModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => miscState.set('isMeetupsCommentModalOpen', false)}>
            <MeetupsCommentModal
              currentMeetup={currentMeetupForComment}
              setIsCommentModalOpen={(value: boolean) => miscState.set('isMeetupsCommentModalOpen', value)}
            />
          </div>
        )}
      </div>
      {isDescrOpen && (
        <div className="flex flex-col gap-3 flex-1 overflow-hidden">
          <div className="bg-white rounded-xl shadow-sm p-3 sm:p-4 md:p-5 lg:h-[90vh] flex-col flex justify-center items-center overflow-y-auto">
            <MeetupsDescrCard />
          </div>
          <div className="bg-white rounded-xl shadow-sm p-3 sm:p-4 md:p-4">
            <MeetupsDescrCardButton
              handleApprove={handleApprove}
              setIsRejectModalOpen={setIsRejectModalOpen}
            />
          </div>
        </div>
      )}
    </div>
  );
}
